'use client';

import { useState, useEffect } from 'react';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import AppLogo from '@/components/ui/AppLogo';
import Icon from '@/components/ui/AppIcon';

const navLinks = [
  { label: 'Accueil', href: '/homepage' },
  { label: 'Services', href: '/services' },
  { label: 'Suivi commande', href: '/order-tracking' },
];

export default function Header() {
  const pathname = usePathname();
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <>
      <header
        className={`fixed top-0 left-0 w-full z-[200] transition-all duration-500 ${
          scrolled
            ? 'bg-white/90 backdrop-blur-xl shadow-[0_2px_24px_rgba(13,27,62,0.08)] border-b border-[rgba(13,27,62,0.06)]'
            : 'bg-transparent'
        }`}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 h-16 sm:h-20 flex items-center justify-between">
          {/* Logo */}
          <Link href="/homepage" className="flex items-center gap-2.5 group">
            <AppLogo
              size={48}
              text="SocialBoost"
              iconName="BoltIcon"
              className="group-hover:scale-105 transition-transform duration-300"
            />
          </Link>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center gap-1">
            {navLinks?.map((link) => (
              <Link
                key={link?.href}
                href={link?.href}
                className={`px-4 py-2 rounded-full text-sm font-semibold transition-all duration-300 ${
                  pathname === link?.href
                    ? scrolled
                      ? 'text-[#1877F2] bg-[rgba(24,119,242,0.08)]'
                      : 'text-white bg-white/15'
                    : scrolled
                    ? 'text-[#0D1B3E] hover:text-[#1877F2] hover:bg-[rgba(24,119,242,0.06)]'
                    : 'text-white/80 hover:text-white hover:bg-white/10'
                }`}
              >
                {link?.label}
              </Link>
            ))}
          </nav>

          {/* CTA */}
          <div className="hidden md:flex items-center gap-3">
            <Link
              href="/services"
              className="btn-primary px-6 py-2.5 text-sm"
              style={{ borderRadius: 50, display: 'inline-block', background: 'linear-gradient(135deg,#1877F2 0%,#1565C0 100%)', color: 'white', fontFamily: 'Plus Jakarta Sans,sans-serif', fontWeight: 700, boxShadow: '0 4px 20px rgba(24,119,242,0.3)', transition: 'all 0.3s', textDecoration: 'none', padding: '10px 22px', fontSize: 14 }}
            >
              🚀 Commander
            </Link>
          </div>

          {/* Mobile menu button */}
          <button
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-xl"
            style={{ background: scrolled ? 'rgba(13,27,62,0.06)' : 'rgba(255,255,255,0.12)' }}
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="Menu mobile"
          >
            <Icon
              name={mobileOpen ? 'XMarkIcon' : 'Bars3Icon'}
              size={22}
              className={scrolled ? 'text-[#0D1B3E]' : 'text-white'}
            />
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileOpen && (
          <div className="md:hidden bg-white border-t border-[rgba(13,27,62,0.06)] shadow-xl mobile-menu-enter">
            <div className="px-4 py-4 space-y-1">
              {navLinks?.map((link) => (
                <Link
                  key={link?.href}
                  href={link?.href}
                  onClick={() => setMobileOpen(false)}
                  className={`block px-4 py-3 rounded-xl text-sm font-semibold transition-all ${
                    pathname === link?.href
                      ? 'text-[#1877F2] bg-[rgba(24,119,242,0.08)]'
                      : 'text-[#0D1B3E] hover:bg-[rgba(13,27,62,0.04)]'
                  }`}
                >
                  {link?.label}
                </Link>
              ))}
              <Link
                href="/services"
                onClick={() => setMobileOpen(false)}
                className="block mt-2 text-center py-3 rounded-xl text-sm font-bold text-white"
                style={{ background: 'linear-gradient(135deg,#1877F2,#1565C0)', textDecoration: 'none' }}
              >
                🚀 Commander maintenant
              </Link>
            </div>
          </div>
        )}
      </header>
    </>
  );
}